/**
 * Vuex module for call queues.
 */
import debug from 'debug'
import RingStrategy from 'Store/class/ring_strategy'
import events from 'Store/events'
import API from '@/api'

const dbg = debug('store:action:ringStrategies:')

const actions = {
  get ({ commit }) {
    dbg('loading ring strategies')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      return API.getRingStrategies()
        .then(response => {
          commit('ADD', response.data)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get contacts'
          events.pubError(msg)
          reject(err)
        })
    })
  }
}

const mutations = {
  ADD (state, data) {
    const ringStrategies = []
    data.forEach(ringStrategy => {
      ringStrategies.push(new RingStrategy(ringStrategy))
    })
    state.ringStrategies = ringStrategies
  }
}

const state = {
  ringStrategies: []
}

const getters = {
  ringStrategies: state => state.ringStrategies
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
